import { shibLogout } from 'api/users';

export const PersistLogin = store => next => action => {
  if (
    action.type === 'LOGIN_FULFILLED' ||
    action.type === 'SHIB_LOGIN_SUCCESS' ||
    action.type === 'REFRESH_TOKEN_FULFILLED'
  ) {
    if (
      sessionStorage.getItem('token') !== action.payload.data.jwt_token &&
      sessionStorage.getItem('token') !== ''
      // the && is to not allow users to login if the logout payload is ''
    ) {
      try {
        sessionStorage.setItem('token', action.payload.data.jwt_token);
      } catch (err) {
        console.error(
          'There was an error setting the token in session storage: ',
          err
        );
      }
    }
  }
  if (action.type === 'FETCH_APP_USER_FULFILLED') {
    const token = action.payload.data.jwt_token;
    if (sessionStorage.getItem('token') !== token) {
      try {
        sessionStorage.setItem('token', token);
      } catch (err) {
        console.error(
          'There was an error setting the token in session storage: ',
          err
        );
      }
    }
  }
  if (action.type === 'LOGOUT') {
    const { appUser } = store.getState().auth;
    if (appUser && appUser.ssoUser) {
      shibLogout();
    }

    try {
      sessionStorage.setItem('token', action.payload);
    } catch (err) {
      console.error('Unable to clear the user token: ', err);
    }
  }
  return next(action);
};
